var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notwx"},[_c('van-icon',{staticClass:"txt",attrs:{"name":"warning","size":"18px","color":"#1989fa"}}),_vm._v(" 请用微信客户端打开该链接！ ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }